// import { useParams } from "react-router-dom";
// import { useEffect, useState } from "react";
// import API from "../api/api";
// import Footer from "../components/Footer";
// import ArticleCard from "../components/ArticleCard";

// export default function CategoryPage() {
//     const { cat } = useParams();

//     const [articles, setArticles] = useState([]);
//     const [page, setPage] = useState(1);
//     const [totalPages, setTotalPages] = useState(1);
//     const [loading, setLoading] = useState(true);

//     useEffect(() => {
//         setLoading(true);

//         API
//             .get(`/articles/category/${cat}?page=${page}`)
//             .then(res => {
//                 setArticles(res.data.articles);
//                 setTotalPages(res.data.total_pages);
//             })
//             .catch(err => console.log("Category fetch error:", err))
//             .finally(() => setLoading(false));
//     }, [cat, page]);

//     // Reset page when category changes
//     useEffect(() => {
//         setPage(1);
//     }, [cat]);

//     return (
//         <div className="w-full">
//             <div className="px-6 py-10 max-w-7xl mx-auto">

//                 {/* PAGE TITLE */}
//                 <h1 className="text-3xl font-bold mb-6 border-l-4 border-blue-600 pl-3 capitalize">
//                     {cat.replace(/_/g, " ")} Articles
//                 </h1>

//                 {/* LOADING */}
//                 {loading && (
//                     <p className="text-center text-gray-500">Loading articles...</p>
//                 )}

//                 {/* ARTICLES */}
//                 {!loading && articles.length > 0 && (
//                     <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
//                         {articles.map(article => (
//                             <ArticleCard
//                                 key={article.slug}
//                                 slug={article.slug}
//                                 img={article.images}
//                                 title={article.title}
//                                 category={article.category}
//                             />
//                         ))}
//                     </div>
//                 )}

//                 {/* EMPTY */}
//                 {!loading && articles.length === 0 && (
//                     <p className="text-gray-600 text-lg">
//                         No articles in this category.
//                     </p>
//                 )}

//                 {/* PAGINATION */}
//                 {totalPages > 1 && (
//                     <div className="flex justify-center items-center gap-4 mt-10">

//                         <button
//                             disabled={page === 1}
//                             onClick={() => setPage(p => p - 1)}
//                             className="px-4 py-2 border rounded disabled:opacity-40"
//                         >
//                             ← Previous
//                         </button>

//                         <span className="px-4 py-2 bg-gray-100 rounded font-semibold">
//                             Page {page} of {totalPages}
//                         </span>

//                         <button
//                             disabled={page === totalPages}
//                             onClick={() => setPage(p => p + 1)}
//                             className="px-4 py-2 border rounded disabled:opacity-40"
//                         >
//                             Next →
//                         </button>
//                     </div>
//                 )}
//             </div>

//             <Footer />
//         </div>
//     );
// }

import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import API from "../api/api";
import Footer from "../components/Footer";
import ArticleCard from "../components/ArticleCard";

export default function CategoryPage() {
    const { cat } = useParams();
    const navigate = useNavigate();

    // 🔹 Always keep URL lowercase
    const normalizedCat = cat.toLowerCase();

    // 🔹 Known category overrides (ACRONYMS)
    const CATEGORY_MAP = {
        ai: "AI",
        api: "API",
        ios: "iOS",
        android: "Android"
    };

    // 🔹 Convert slug → DB category safely
    const dbCategory =
        CATEGORY_MAP[normalizedCat] ||
        normalizedCat
            .replace(/-/g, " ")
            .replace(/\b\w/g, c => c.toUpperCase());

    const [articles, setArticles] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(true);

    // 🔁 Auto-redirect uppercase URL → lowercase
    useEffect(() => {
        if (cat !== normalizedCat) {
            navigate(`/category/${normalizedCat}`, { replace: true });
        }
    }, [cat, normalizedCat, navigate]);

    // 🔹 Fetch using exact DB category
    useEffect(() => {
        setLoading(true);

        API
            .get(`/articles/category/${dbCategory}?page=${page}`)
            .then(res => {
                setArticles(res.data.articles || []);
                setTotalPages(res.data.total_pages || 1);
            })
            .catch(err => console.log("Category fetch error:", err))
            .finally(() => setLoading(false));
    }, [dbCategory, page]);

    // Reset page when category changes
    useEffect(() => {
        setPage(1);
    }, [dbCategory]);

    return (
        <div className="w-full">
            <div className="px-6 py-10 max-w-7xl mx-auto">

                {/* SEO H1 (hidden safely) */}
                <h1 className="sr-only">
                    {dbCategory} Articles
                </h1>

                {/* Visible Title */}
                <h2 className="text-3xl font-bold mb-6 border-l-4 border-blue-600 pl-3">
                    {dbCategory} Articles
                </h2>

                {/* LOADING */}
                {loading && (
                    <p className="text-center text-gray-500">
                        Loading articles...
                    </p>
                )}

                {/* ARTICLES */}
                {!loading && articles.length > 0 && (
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                        {articles.map(article => (
                            <ArticleCard
                                key={article.slug}
                                slug={article.slug}
                                img={article.images}
                                title={article.title}
                                category={article.category}
                            />
                        ))}
                    </div>
                )}

                {/* EMPTY */}
                {!loading && articles.length === 0 && (
                    <p className="text-gray-600 text-lg">
                        No articles in this category.
                    </p>
                )}

                {/* PAGINATION */}
                {totalPages > 1 && (
                    <div className="flex justify-center items-center gap-4 mt-10">
                        <button
                            disabled={page === 1}
                            onClick={() => setPage(p => p - 1)}
                            className="px-4 py-2 border rounded disabled:opacity-40"
                        >
                            ← Previous
                        </button>

                        <span className="px-4 py-2 bg-gray-100 rounded font-semibold">
                            Page {page} of {totalPages}
                        </span>

                        <button
                            disabled={page === totalPages}
                            onClick={() => setPage(p => p + 1)}
                            className="px-4 py-2 border rounded disabled:opacity-40"
                        >
                            Next →
                        </button>
                    </div>
                )}
            </div>

            <Footer />
        </div>
    );
}
